<template>
  <!-- Create Edit-->
  <v-layout wrap justify-center align-center>
    <v-flex xs12 class="text-xs-right">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" :loading="loadingFields">
            Adicionar Campo
            <v-icon dark>{{translate('system.button.add.icon')}}</v-icon>
          </v-btn>
        </template>
        <v-list dense v-if="filterTaskFields.length > 0">
          <template v-for="(customField, index) in filterTaskFields">
            <v-subheader v-if="customField['type'] === 'custom'" :key="index">{{ customField['header'] }}</v-subheader>
            <v-list-tile v-else @click="createItem(customField)" :key="index">
                <v-icon style="padding-right: 5px;">{{getFieldIcon(customField['type'])}}</v-icon>
               {{customField['title']}}
            </v-list-tile>
          </template>
        </v-list>
        <v-list dense v-else>
          <v-list-tile>Adicione campos personalizados na tarefa modelo para mais opções.</v-list-tile>
        </v-list>
      </v-menu>
    </v-flex>
    <v-list subheader two-line style="width:100%">
      <draggable id="list-form-custom-field" v-model="items" v-bind="dragOptions" draggable=".drag-form-custom-field" handle=".handle">
          <v-hover :key="'h' + index" v-for="(item, index) in items" class="drag-form-custom-field">
            <v-list-tile slot-scope="{ hover }" :key="index" style="padding-left: 0px !important;" class="handle">
              <v-icon v-show="hover || $vuetify.breakpoint.smAndDown" class="grab-form-field">view_week</v-icon>
              <v-list-tile-content>
                  <v-list-tile-title class="list-title-form-field">
                    <v-icon>{{getFieldIcon(item['custom_field']['type'])}}</v-icon>
                    <span slot="activator" class="show-edit">{{item['custom_field']['title']}}</span>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-checkbox
                    hide-details
                    class="small-checkbox checkbox-form-field"
                    v-model="item['required']"
                    label="Campo Obrigatório"
                  ></v-checkbox>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action v-show="hover || $vuetify.breakpoint.smAndDown">
              <!-- <v-flex shrink> -->
                <v-tooltip top v-show="hover || $vuetify.breakpoint.smAndDown">
                  <v-btn icon class="mx-0" slot="activator" @click="deleteItem(item['custom_field_id'])">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                  <span>Excluir</span>
                </v-tooltip>
              <!-- </v-flex> -->
              </v-list-tile-action>
            </v-list-tile>
          </v-hover>
      </draggable>
      <v-list-tile three-line v-if="items.length === 0">
        Adicione uma opção
      </v-list-tile>
    </v-list>
  </v-layout>
</template>

<style scoped>
  .background-expanded {
    background-color:rgb(223, 223, 223);
  }
  .show-edit {
    /* min-height: 50px; */
    padding: 5px;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0);
    /* padding-left: 5px; */
  }
  .list-title-form-field {
    border-bottom: 1px solid;
    margin-bottom: 3px;
    height: 30px;
  }
  .checkbox-form-field {
    margin-left: 30px;
    margin-top: 0px;
    padding-top: 0px;
    height: 20px;
  }
  .handle {
    cursor: grab;
  }
  .grab-form-field {
    left: -15px;
    position: absolute;
  }
</style>
<script>
  /* eslint-disable eqeqeq */
  import draggable from 'vuedraggable'
  export default {
    name: 'PFormCustomField',
    components: {draggable},
    props: {
      tasktemplate_id: {
        type: Number,
        default: 0
      },
      formCustomFields: {
        type: Array,
        default: () => { return [] }
      }
    },
    data: () => ({
      view: 1,
      loadingFields: false,
      customFields: [],
      items: [],
      // Armazena o valor antigo caso o usuário comece a edição de algum form custom field e vai no x
      beforeItem: {},
      entity: 'custom_fields',
      dragOptions: {
        animation: 200,
        group: 'list-form-custom-field',
        disabled: false
      }
    }),
    created () {
      this.items = this.formCustomFields.map(val => {
        let field = JSON.parse(JSON.stringify(val))
        // verifica se o custom_field_id é um numero pois se não for significa que ele é um campo normal da tarefa e não um campo personalizado
        if (isNaN(field['custom_field_id'])) {
          // caso seja um campo normal, insere os valores no custom_field pois esses valores são usados para mostrar o campo no front
          field['custom_field'] = this.translate('value.tasktemplate_form_fields').find((value) => value['id'] === field['custom_field_id'])
          return field
        } else {
          return field
        }
      })
      this.mountCustomFields()
    },
    methods: {
      createItem (option) {
        this.view = 2
        this.items.push({custom_field_id: option['id'], custom_field: option, id_text: '', required: false, opened: false})
      },
      deleteItem (customFieldId) {
        this.items = this.items.filter((item) => { return item.custom_field_id != customFieldId })
      },
      // Fecha os outros campos que possivelmente estão abertos
      // closeOthersItems (customFieldId = '') {
      //   this.items.forEach((val) => {
      //     if (val['custom_field_id'] != customFieldId) val['opened'] = false
      //   })
      // },
      closeEditCustomField (item) {
        this.view = 1
        // retorna pro valor antigo
        Object.assign(item, this.beforeItem)
        this.beforeItem = {}
      },
      mountCustomFields () {
        this.loadingFields = true
        this.customFields = []
        // adicionas o header de campos
        this.customFields.push({header: 'Campos', type: 'custom'})
        // insere todos os campos da tarefa
        Array.prototype.push.apply(this.customFields, this.translate('value.tasktemplate_form_fields'))
        // adicionas o header de campos personalizados
        this.customFields.push({header: 'Campos Personalizados', type: 'custom'})
        this.$http.get(`api/custom_fields?origin_field_name=tasktemplate_id&tasktemplate_id=${this.tasktemplate_id}`).then((res) => {
          // insere 1 por 1 pois ai inserir todos de uma vez não aparecia no front
          res.body.map((val) => this.customFields.push(val))
          this.loadingFields = false
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
        })
      },
      getFieldIcon (type) {
        let result = ''
        switch (type) {
          case 'number':
            result = 'pin'
            break
          case 'value':
            result = 'attach_money'
            break
          case 'string':
            result = 'notes'
            break
          case 'select':
            result = 'check_box'
            break
          case 'multiselect':
            result = 'library_add_check'
            break
          case 'date':
            result = 'calendar_today'
            break
          case 'datetime':
            result = 'schedule'
            break
          case 'files':
            result = 'file_present'
            break
          case 'phone':
            result = 'phone'
            break
          case 'email':
            result = 'email'
            break
        }
        return result
      }
    },
    computed: {
      // busca apenas campos que ainda não foram adicionados
      filterTaskFields () {
        return this.customFields.filter((val) => { return !this.items.some((item) => { return item['custom_field_id'] == val['id'] }) })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PFormCustomField.vue